
<template>
  <div class="clients">
      <div class="lbbox">
        <img :src="bgimg" alt="" class="icon">
        <div class="box">
            <p class="ptitle">- Our Clients - </p>
           
         <div class="swiper-container" v-if="listData.length>0">

            <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item,index) in listData" :key="item.id" >

                     <div class="imgbox">
                         <img :src="item.content.img" alt="" class="lbimg" @click="setimg(index)">
                     </div>
                  </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
         </div>
        </div>
      </div>
      
      <div class="showimgbox2" v-show="showimg">
        
         <div class="showimghead">
            <div :class="quan?'qpbtn this':'qpbtn'" @click="toggleFullScreen()"></div>
            <div class="close"  @click="gbimg()">
               
            </div>
         </div>
         <div class="showbody">
             <div class="prev" @click="goprev()" v-if="thisindex!=0">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z"></path></g></svg>
             </div>
             <div class="showimgbox">
                     <img :src="thisimg" alt="" class="showimg">
             </div>
             <div class="next" @click="gonext()" v-if="thisindex < total">
              <svg fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z"></path></g></svg>
             </div>
         </div>
      </div>
 </div>
 
</template>
<!-- filter: blur(18px) grayscale(0); -->
<script>
import { Recommend} from '../../api/userMG'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'

import 'wowjs/css/libs/animate.css'
export default {
  name:'clients',
  data() {
    return {
       quan:false,
       showimg:false,
        bgimg:require("@/assets/img/bg5.jpg"),
        webname:'nomomo',
      webkey:'激光脫毛</br>​激光祛斑祛印',
      listData:[],
      thisimg:'',
    swiper:null,
    params:{
        mt_id:5
      },
     num:document.documentElement.clientWidth > 1600 ? 5 : (document.documentElement.clientWidth > 1200 ? 4 : 2),
     thisindex:0,
     total:0
    }
  },
  // 註冊組件
  components: {

 
    
  },
  /**
   * 數據發生改變
   */

  /**
   * 創建完畢
   */
  created() {
    
  },
  mounted() {
    this.getdata(this.params)

   
},
  /**
   * 裏麵的方法隻有被調用才會執行
   */
  methods: {
    goprev(){
      this.thisindex--
      this.thisimg=this.listData[this.thisindex].content.img
    },
    gonext(){
      this.thisindex++
      this.thisimg=this.listData[this.thisindex].content.img
    },
    gbimg(){
      this.exitFullScreen();
      this.showimg=false

    },
     toggleFullScreen() {
      if (!document.fullscreenElement) {
        this.enterFullScreen();
        
      } else {
        this.exitFullScreen();
      }
    },
    enterFullScreen() {
      this.quan=true
      let element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen();
      }
    },
    exitFullScreen() {
      this.quan=false
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    setimg(index){
     
      this.thisimg=this.listData[index].content.img
      this.showimg=true
      this.thisindex=index
    },
    // 獲取公司列錶
    getdata(parameter) {
      this.loading = true
    

      Recommend(parameter)
        .then(res => {
          this.loading = false
    
          if (res.data.code != 1) {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          } else {
            res.data.data.data.forEach(el => {
              el.content=JSON.parse(el.content)
          
            });
            this.listData = res.data.data.data
            this.total=res.data.data.total
            this.$nextTick(()=>{
      this.getSwiper()
    })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜單加載失敗，請稍後再試！')
        })
    },
   getSwiper(){
         this.swiper=new Swiper(".swiper-container",{
    
          autoplay:{ delay: 0,


    
           pauseOnMouseEnter:true,
      disableOnInteraction:false,},
          
   
                  speed:5000,

             
               slidesPerView:this.num,
               spaceBetween:30,
      
               navigation:{
                nextEl:'.swiper-button-next',
                prevEl:'.swiper-button-prev'
               },
               observer:true,
               observeParents:true,
               resizeObserver: true,
               loop:true,
         })


   }
   
  }
}
</script>

<style scoped>
.wow { visibility: hidden; }
 .swiper-wrapper {
    -webkit-transition-timing-function: linear;
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}
</style>
 
 


// WEBPACK FOOTER //
// src/views/home/clients.vue